import { z } from 'zod'

/** Longueur minimale d'un mot de passe. Miroir de `MIN_PASSWORD_LENGTH` côté API, qui l'applique aussi (#77). */
export const MIN_PASSWORD_LENGTH = 8

/**
 * Règle d'un NOUVEAU mot de passe, partagée par tous les écrans qui en
 * choisissent un. Le message est passé par l'appelant : il est traduit, et le
 * schéma se construit dans le composant qui a `t`.
 */
export function passwordRule(message: string) {
  return z.string().min(MIN_PASSWORD_LENGTH, { message })
}
